export const toSearchString = (record: Record<string, any>) => {
  const urlSearchParams = new URLSearchParams('');
  Object.entries(record).forEach(([key, value]) => {
    if (typeof value !== 'undefined' && value !== null) {
      if (Array.isArray(value)) {
        value.forEach(element => urlSearchParams.append(`${key}[]`, element));
        return;
      }

      urlSearchParams.set(key, value);
    }
  });
  return urlSearchParams.toString();
};

export const fromSearchString = <TParseValue extends boolean = false>
  (search: string, retrieveAsArray = false)
  : Record<string, TParseValue extends true ? string|string[] : string> => {
  const urlSearchParams = new URLSearchParams(search);
  return Object.fromEntries(Array.from(urlSearchParams.keys()).map(key => {
    if (retrieveAsArray && key.endsWith('[]')) {
      return [key.replace(/\[]$/, ''), urlSearchParams.getAll(key)];
    }

    return [key, urlSearchParams.get(key)];
  }));
};
